module.exports = __webpack_public_path__ + "static/img/tongxun.4aa497c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/tongxun.png
// module id = +t0j
// module chunks = 1